import React from 'react';

// Text with **bold** runs, as the assistant's meeting summary marks its
// section titles. Everything else stays plain, at the same size. Used where
// an activity's description is shown; nothing else interprets the markers.
const BOLD = /\*\*([^*\n]+?)\*\*/g;

export function splitBold(text) {
  const s = String(text == null ? '' : text);
  const out = [];
  let last = 0;
  let m;
  BOLD.lastIndex = 0;
  while ((m = BOLD.exec(s))) {
    if (m.index > last) out.push({ bold: false, text: s.slice(last, m.index) });
    out.push({ bold: true, text: m[1] });
    last = m.index + m[0].length;
  }
  if (last < s.length) out.push({ bold: false, text: s.slice(last) });
  return out;
}

/** The same text with the markers removed, for a one-line preview. */
export function stripBold(text) {
  return String(text == null ? '' : text).replace(BOLD, '$1');
}

export default function BoldText({ text }) {
  if (!text) return null;
  const parts = splitBold(text);
  if (parts.length === 1 && !parts[0].bold) return parts[0].text;
  return <>{parts.map((p, i) => (p.bold ? <strong key={i}>{p.text}</strong> : <React.Fragment key={i}>{p.text}</React.Fragment>))}</>;
}
